import { HttpClient } from '#client/http/index'
import {
  FacilityListParams,
  FacilitySort,
  FacilityOrder,
  LocationSearchParams,
  ListFacility,
  BaseFacility,
  CampaignFacility,
  SearchResponse,
  SearchMetadata,
  SearchCountParams,
  ProgramSearchCountResponse,
  FacilityId,
  FacilityDetails,
  Program,
  Timetable,
  FacilityReview,
  GetCityNameByCodeResponse,
} from '#client/resources/index'
import { ApiResponse, PagerMeta, PagerParams } from '#client/resources/types'

export const list = async (
  { httpClient }: { httpClient: HttpClient },
  params: FacilityListParams,
) => {
  const searchParams = {
    ...params,
    sortBy: params.sortBy ?? FacilitySort.MINIMUM_POINT,
    order:
      params.order ?? (params.sortBy ? FacilityOrder.DESC : FacilityOrder.ASC),
    excludeFullReservations: params.excludeFullReservations ? 1 : 0,
    omitPrograms: (params as LocationSearchParams).omitPrograms ? 1 : 0,
  }

  const { data, meta }: ApiResponse<ListFacility[], PagerMeta> =
    await httpClient.get('/user/facilities', {
      params: searchParams,
    })
  return { data, meta }
}

export const listRecommended = async ({
  httpClient,
}: {
  httpClient: HttpClient
}) => {
  const { data }: ApiResponse<BaseFacility[]> = await httpClient.get(
    '/user/facilities/recommended',
  )
  return data
}

export const listCampaign = async ({
  httpClient,
}: {
  httpClient: HttpClient
}) => {
  const { data }: ApiResponse<CampaignFacility[]> = await httpClient.get(
    '/user/facilities/campaign',
  )
  return data
}

/**
 * @deprecated 施設検索を置き換えたら廃止
 */
export const search = async ({ httpClient }: { httpClient: HttpClient }) => {
  const { data }: ApiResponse<SearchResponse> = await httpClient.get(
    '/user/facilities/search',
  )
  return data
}

export const searchMetadata = async ({
  httpClient,
}: {
  httpClient: HttpClient
}) => {
  const { data }: ApiResponse<SearchMetadata> = await httpClient.get(
    '/user/facilities/meta',
  )
  return data
}

export const searchCount = async (
  { httpClient }: { httpClient: HttpClient },
  params: SearchCountParams,
) => {
  const { data }: ApiResponse<ProgramSearchCountResponse> =
    await httpClient.get('/user/facilities/count', {
      params: {
        ...params,
        excludeFullReservations: params.excludeFullReservations ? 1 : 0,
        omitPrograms: (params as LocationSearchParams).omitPrograms ? 1 : 0,
      },
    })
  return data
}

export const get = async (
  { httpClient }: { httpClient: HttpClient },
  id: FacilityId,
): Promise<FacilityDetails> => {
  const { data }: ApiResponse<FacilityDetails> = await httpClient.get(
    `/user/facilities/${id}`,
  )
  return data
}

export const loadMorePrograms = async (
  { httpClient }: { httpClient: HttpClient },
  id: FacilityId,
) => {
  const { data }: ApiResponse<Program[]> = await httpClient.get(
    `/user/facilities/${id}/programs`,
  )
  return data
}

export const listTimetables = async (
  { httpClient }: { httpClient: HttpClient },
  id: FacilityId,
) => {
  const { data }: ApiResponse<Timetable[]> = await httpClient.get(
    `/user/facilities/${id}/timetables`,
  )
  return data
}

export const listReviews = (
  { httpClient }: { httpClient: HttpClient },
  id: FacilityId,
  pager?: PagerParams,
): Promise<ApiResponse<FacilityReview[], PagerMeta>> =>
  httpClient.get(`/user/facilities/${id}/reviews`, { params: pager })

export const getCityNameByCode = async (
  { httpClient }: { httpClient: HttpClient },
  cityCode: string,
) => {
  const { data }: ApiResponse<GetCityNameByCodeResponse> = await httpClient.get(
    `/user/facilities/cityNameByCode/${cityCode}`,
  )

  return data
}

export const listByNearbyRegisteredAddress = async ({
  httpClient,
}: {
  httpClient: HttpClient
}) => {
  const { data }: ApiResponse<BaseFacility[]> = await httpClient.get(
    '/user/facilities/near-registered-address',
  )
  return data
}
